import PropTypes from 'prop-types'
import SideMenu from './SideMenu.jsx'
import { ArrowDownToLine, ArrowUpFromLine, Rotate3d, Smartphone } from 'lucide-react'

// Cómo se mira la pieza en el 3D (C3D-8). Solo cambia la vista: el modelo, el
// 3MF y la impresión no se enteran.
const ORIENTATIONS = [
    { value: 'flat', label: 'Boca arriba', Icon: ArrowUpFromLine },
    { value: 'flipped', label: 'Boca abajo', Icon: ArrowDownToLine },
    { value: 'upright', label: 'De pie', Icon: Smartphone },
]

const DropdownViewOrientation = ({ value = 'flat', onChange }) => (
    <SideMenu
        tip="Posición de la pieza"
        icon={<Rotate3d className="h-8 w-8" />}
        menuClassName="menu w-48 gap-1 p-2"
    >
            {ORIENTATIONS.map(({ value: option, label, Icon }) => (
                <button
                    key={option}
                    type="button"
                    className={`btn btn-sm justify-start gap-2 ${value === option ? 'btn-primary' : 'btn-ghost'}`}
                    aria-pressed={value === option}
                    onClick={() => onChange(option)}
                >
                    <Icon className="h-4 w-4" />
                    {label}
                </button>
            ))}
    </SideMenu>
)

DropdownViewOrientation.propTypes = {
    value: PropTypes.oneOf(ORIENTATIONS.map(({ value }) => value)),
    onChange: PropTypes.func.isRequired,
}

export default DropdownViewOrientation
